import React from 'react';

import Price from '~/shared/components/price';
import { LIMIT_OF_CHARACTERS } from '~/shared/constants';
import { getValidatePhone, validate, validator } from '~/shared/helpers/validation-helpers';

const getPaymentFormConfig = ({
  t,
  pattern,
  price,
  isFreeCourse,
  isDisableFormFields,
}: {
  pattern: string;
  price: number;
  t: (key: string, options: { ns: string[] }) => string;
}) => {
  const validation = validator({ t });

  return {
    name: 'paymentForm',
    pattern,
    textAlign: 'center',
    position4: {
      formFields: [
        {
          name: 'firstName',
          label: t('field.first-name.title'),
          disabled: isDisableFormFields,
          validate: validate([
            validation.required,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.FIRST_NAME.MIN,
              max: LIMIT_OF_CHARACTERS.FIRST_NAME.MAX,
            }),
          ]),
          type: 'text',
        },
        {
          name: 'phone',
          label: t('field.phone.title'),
          placeholder: t('field.your-phone-number.placeholder'),
          disabled: isDisableFormFields,
          validate: validate([
            validation.required,
            validation.phoneValid,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.PHONE_NUMBER.MIN,
              max: LIMIT_OF_CHARACTERS.PHONE_NUMBER.MAX,
            }),
          ]),
          type: 'phone-input',
          config: {
            enableSearch: true,
            getValidate: getValidatePhone(null, validation),
          },
        },
        {
          name: 'email',
          label: t('field.email.title'),
          disabled: isDisableFormFields,
          validate: validate([
            validation.required,
            validation.isEmail,
            validation.isInRange.bind(null, {
              min: LIMIT_OF_CHARACTERS.EMAIL.MIN,
              max: LIMIT_OF_CHARACTERS.EMAIL.MAX,
            }),
          ]),
          type: 'text',
        },
        {
          name: 'termsAndConditions',
          type: 'checkbox',
          validate: validate([validation.required]),
          label: (
            <div
              dangerouslySetInnerHTML={{
                __html: t('text.agreement-with-service-provider') ?? '',
              }}
            />
          ),
          validate: validate([validation.required]),
        },
        ...(isFreeCourse
          ? []
          : [
              {
                name: 'price',
                type: 'custom-field',
                render: ({ value, setValue, getValues }) => {
                  return () => <Price price={price} t={t} />;
                },
              },
            ]),
      ],
    },
    actions: {
      buttons: [
        {
          name: 'submit',
          htmlType: 'submit',
          size: 'large',
          className: 'action-button--yellow',
          buttonName: t(isFreeCourse ? 'button.get-course' : 'button.go-to-payment'),
        },
      ],
    },
  };
};

export default getPaymentFormConfig;
